<app-splash-screen></app-splash-screen>
<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu
      contentId="main-content"
      [disabled]="(logedIn$ | async) === false"
      id="app-side-menu"
      type="overlay">
      <ion-header>
        <ion-toolbar>
          <ion-row>
            <ion-col>
              <app-user-profile-toolbar></app-user-profile-toolbar>
            </ion-col>
          </ion-row>
        </ion-toolbar>
      </ion-header>

      <!-- Aufbau Menu Sidebar Items -->
      <ion-content>
        <!-- Neue kapselte Komponente rendert die gesamte Menüstruktur -->
        <app-side-menu
          [requestedAbsences]="requestedAbsences$ | async"
          [loggedIn]="logedIn$ | async"></app-side-menu>
      </ion-content>

      <ion-footer>
        <ion-toolbar>
          <ion-row class="ion-justify-content-left">
            <ion-col class="ion-no-padding brand-logo-spacing" size="4">
              <a href="https://www.admia.ch/" target="_blank">
                <img class="brand-logo" src="../assets/images/admia.png" />
              </a>
            </ion-col>
            <ion-col>
              <div class="ion-float-end">
                <ion-button
                  data-tippy-content="User Manual öffnen"
                  (click)="helpNav()"
                  fill="clear"
                  size="default">
                  <ion-icon name="help-circle-outline"></ion-icon>
                </ion-button>
                <ion-button
                  data-tippy-content="TeamViewer Support"
                  (click)="support()"
                  fill="clear"
                  size="default">
                  <ion-icon name="help-buoy-outline"></ion-icon>
                </ion-button>
                <ion-button
                  data-tippy-content="Einstellungen öffnen"
                  (click)="settingsNav()"
                  fill="clear"
                  size="default">
                  <ion-icon name="settings-outline"></ion-icon>
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <ion-router-outlet animated="false" id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <app-default-header
    *ngIf="
      ((online$ | async) === false || (servicePause$ | async)) &&
      (onNativeLoginPage$ | async) === false
    "></app-default-header>
</ion-app>
